export enum IsbnTypeEnum {
  Book,
  CassetteCD,
  EBook,
  ComputerSoftware,
  Map,
  MicroFilm,
  Others
}
